module.exports = __webpack_public_path__ + "sh.svg?b696c28daf0547f5dda747d0651bc1ff";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/sh.svg
// module id = 1374
// module chunks = 27